import React from 'react';

import {PremiumFeature} from '../../types';
import {Icon} from '../../components';
import {colors} from '../../theme';

export const PremiumFeatures = ({features}: {features: PremiumFeature[]}) => {
  return (
    <div className="flex flex-col">
      <div className="flex flex-row items-center my-2 gap-2">
        <div className="flex flex-1">
          <p className="text-largebodymob lg:text-largebody font-semibold">
            What&apos;s included
          </p>
        </div>

        <div className="w-16 flex flex-col items-center text-center">
          <span className="text-smallbodymob lg:text-smallbody font-semibold">
            Premium
          </span>
        </div>

        <div className="w-16 flex flex-col items-center text-center">
          <span className="text-smallbodymob lg:text-smallbody font-semibold">
            Free
          </span>
        </div>
      </div>

      {features.map(f => {
        return (
          <div key={f.title} className="flex flex-row items-center my-2 ">
            <div className="flex flex-1">
              <p className="text-largebodymob lg:text-largebody">{f.title}</p>
            </div>

            <div className="w-16 flex flex-col items-center text-center ml-4">
              {f.includedInPremiumTier && (
                <>
                  {f.premiumTierSpecifics ? (
                    <div className="text-caption bg-bluerice px-2 py-1 rounded-full">
                      {f.premiumTierSpecifics}
                    </div>
                  ) : (
                    <Icon
                      iconName="tick-circle"
                      color={colors.black}
                      fill={colors.bluerice}
                      width={24}
                      height={24}
                    />
                  )}
                </>
              )}
            </div>

            <div className="w-16 flex flex-col items-center text-center ml-2">
              {f.includedInFreeTier && (
                <>
                  {f.freeTierSpecifics ? (
                    <span className="text-caption">{f.freeTierSpecifics}</span>
                  ) : (
                    <Icon
                      iconName="tick-circle"
                      color={colors.black}
                      fill={'#fff'}
                      width={24}
                      height={24}
                    />
                  )}
                </>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
};
